export default "__VITE_ASSET__dfe64104__$_?react__"